/* ------------ CONFIGURATION ------------ */

import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Label} from 'ng2-charts';

export const barChartType: ChartType = 'bar';

export const barChartData: ChartDataSets[] = [
  { data: [0], label: 'Questionario' },
];

export const barChartLabels: Label[] = [
  ''
];

export const barChartOptions: ChartOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  title: {
    display: true,
    text: 'Livello salute',
    position: 'top',
    fontSize: 15,
    fontStyle: 'bold',
    fontColor: 'black',
    fontFamily: 'Exo, sans-serif',
    padding: 40
  },
  responsive: true,
  scales : {
    yAxes: [{
      ticks: {
        max : 100,
        min: 0,
        stepSize: 5
      }
    }]
  }
};

/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireEQ5D5l {
  position: number;
  question: string;
  answers: string[];
}

export const Q_EQ_5D_5L: QuestionnaireEQ5D5l[] = [
  {
    position: 1, question: 'Capacità di movimento',
    answers: [
      'Non ho difficoltà nel camminare',
      'Ho lievi difficoltà nel camminare',
      'Ho moderate difficoltà nel camminare',
      'Ho gravi difficoltà nel camminare',
      'Non sono in grado di camminare'
    ]
  },
  {
    position: 2, question: 'Cura della persona',
    answers: [
      'Non ho difficoltà nel lavarmi o vestirmi',
      'Ho lievi difficoltà nel lavarmi o vestirmi',
      'Ho moderate difficoltà nel lavarmi o vestirmi',
      'Ho gravi difficoltà nel lavarmi o vestirmi',
      'Non sono in grado di lavarmi o vestirmi'
    ]
  },
  {
    position: 3, question: 'Attività abituali (per es. lavoro, studio, lavori domestici, attività familiari o di svago)',
    answers: [
      'Non ho difficoltà nello svolgimento delle attività abituali',
      'Ho lievi difficoltà nello svolgimento delle attività abituali',
      'Ho moderate difficoltà nello svolgimento delle attività abituali',
      'Ho gravi difficoltà nello svolgimento delle attività abituali',
      'Non sono in grado di svolgere le mie attività abituali'
    ]
  },
  {
    position: 4, question: 'Dolore o fastidio',
    answers: [
      'Non provo alcun dolore o fastidio',
      'Provo lieve dolore o fastidio',
      'Provo moderato dolore o fastidio',
      'Provo grave dolore o fastidio',
      'Provo estremo dolore o fastidio'
    ]
  },
  {
    position: 5, question: 'Ansia o depressione',
    answers: [
      'Non sono ansioso/a o depresso/a',
      'Sono lievemente ansioso/a o depresso/a',
      'Sono moderatamente ansioso/a o depresso/a',
      'Sono gravemente ansioso/a o depresso/a',
      'Sono estremamente ansioso/a o depresso/a'
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class EQ5D5LResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  scale: number;

  constructor(doctorID: string, patientSSN: string, results: string[], scale: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.scale = scale;
  }

}
